import { render, staticRenderFns } from "./RMAPreview.vue?vue&type=template&id=4c46c0d1&scoped=true&"
import script from "./RMAPreview.vue?vue&type=script&lang=js&"
export * from "./RMAPreview.vue?vue&type=script&lang=js&"
import style0 from "./RMAPreview.vue?vue&type=style&index=0&id=4c46c0d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c46c0d1",
  null
  
)

export default component.exports